import React, { useEffect, useState, useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Card } from "react-bootstrap";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import Illustration from "../../../../partials/content/Illustration";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getSalesmanPerformanceReport } from "../../../../services/crm/crmReportService";
import NumberFormat from "react-number-format";
import { formatDate } from "../../../../utils/utils";
import { DateTime } from "luxon";

function SalesmanPerformanceReport(props) {
  const { reload, companyProfile } = useGlobalData();
  const [salesmanPerformance, setSalesmanPerformance] = useState([]);
  const selectParamOp = useRef(null);
  const [selectParam, setSelectParam] = useState({
    dateFrom: DateTime.fromISO(companyProfile.CreatedAt).startOf("day"),
    dateTo: DateTime.now().endOf("day"),
  });

  useEffect(() => {
    getSalesmanPerformanceData();
  }, [reload]);

  const top5SalesmanDealsColumn = [
    {
      header: "Customer Name",
      field: "customerName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.customerName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Deals Date",
      field: "dealsDate",
      body: (rowData) => formatDate(rowData.dealsDate),
      sortable: true,
      filter: true,
    },
    {
      header: "Deals Value",
      field: "dealsValue",
      body: (rowData) => (
        <NumberFormat
          value={rowData.dealsValue}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={2}
          renderText={(value) => (
            <div className="float-right">
              {rowData.currencyCode} {value}
            </div>
          )}
        />
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Business Size",
      field: "businessSizeName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.businessSizeName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Industry Type",
      field: "industryTypeName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.industryTypeName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Source",
      field: "sourceName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.sourceName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Country",
      field: "countryName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.countryName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
  ];

  return (
    <React.Fragment>
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date From"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateFrom}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateFrom = date;
                        setSelectParam(selectParamTmp);
                      }}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date To"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateTo}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateTo = date;
                        setSelectParam(selectParamTmp);
                      }}
                      minDate={selectParam.dateFrom}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                getSalesmanPerformanceData();
              }}
            >
              <i className="fas fa-search"></i>
              Get Sales Performance
            </button>
          </div>
        </div>
      </OverlayPanel>
      {salesmanPerformance.length ? (
        <React.Fragment>
          <CustomDataTable
            data={salesmanPerformance}
            dataDetailName="salesmanDeals"
            dataDetailColumns={top5SalesmanDealsColumn}
            dataDetailTitle="Top 5 Salesman Deals"
            onRefreshData={() => {
              getSalesmanPerformanceData();
            }}
            buttons={[
              {
                name: "Filter",
                onClick: (e) => {
                  selectParamOp.current.toggle(e);
                },
                icon: "fas fa-search",
                color: "info",
              },
            ]}
            columns={[
              {
                header: "Sales Name",
                field: "salesName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.salesName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Deals Won",
                field: "dealsWon",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Deals Won Value",
                field: "dealsWonValue",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.dealsWonValue}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Deals Lost",
                field: "dealsLost",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Deals Lost Value",
                field: "dealsLostValue",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.dealsLostValue}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Ongoing Deals Value",
                field: "ongoingDealsValue",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.ongoingDealsValue}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Average Deals",
                field: "averageDeals",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.averageDeals}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Win Rate",
                field: "winRate",
                body: (rowData) => (
                  <div className="float-right">{rowData.winRate}%</div>
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO CRM.png"
            description={`You don't have any Salesman Performance for current data selection!`}
            guidance={`Hint: Try to filter another data selection to get some results`}
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-info btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                selectParamOp.current.toggle(e);
              }}
            >
              <i className="fas fa-search"></i>
              Filter
            </button>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );

  async function getSalesmanPerformanceData() {
    const response = await getSalesmanPerformanceReport(
      selectParam.dateFrom,
      selectParam.dateTo
    );
    const { data } = response.data;
    setSalesmanPerformance(data.salesmanPerformanceReport);
  }
}

export default SalesmanPerformanceReport;
